export default "__VITE_ASSET__CBMCvE29__"